<template>
  <div class="content">
    <h4>
      转区/转游说明:
    </h4>
    <p>
      1.老游戏角色已有档位最高抵扣50%的金额；如新游戏所选档位金额低于已有档位金额，则仅能抵扣所选档位金额的50%，即新游戏所选档位金额的一半，转移完成后无法撤回。<br />
      例：<br />
      (1)老游戏角色拥有298元档位权限，若新游戏角色选择198元档位权限，则减免198元档位金额的一半，即99元。玩家需支付99元，新游戏角色将获得198元档位权限。<br />
      (2)老游戏角色拥有298元档位权限，若新游戏角色选择328元档位权限，则减免298元档位金额的一半，即149元。玩家需支付179元，新游戏角色将获得328元档位权限。
    </p>
    <br /><br />
    <p>
      2.新游戏角色如果已经解锁开通过权限，将无法在支持转游。
    </p>
    <p>
      3.每个所选老游戏/老区老角色仅能转游一次，转移完成后将无法撤回，老游戏权限收回并开通至新游戏/新区新角色。
    </p>
    <img src="../../assets/GMdesc/transfer1.png" alt="" />
    <img src="../../assets/GMdesc/transfer2.png" alt="" />
    <p class="about">
      关于老角色转游时的金额减免政策，以下为详细说明：
    </p>
    <p>
      1.减免比例：老角色在转游至新游戏时，最高可享受50%的金额减免。这意味着，如果您在原游戏中的充值金额较高，转游至新游戏时，可以减少一部分支付金额。
    </p>
    <p>
      2.减免条件：减免的金额取决于您在原游戏中的充值金额以及新游戏所选的档位。如果新游戏所选档位的金额低于原游戏中的最高充值金额，则只能按照新游戏所选档位的金额进行50%的减免。
    </p>
    <p>
      3.具体示例：
      ·如果您在原游戏中充值了1000元，而新游戏中的所选档位金额为500元，那么您将享受250元的减免，只需支付250元即可获得新游戏中的相应档位权限。·如果您在原游戏中充值了1000元，但新游戏中的所选档位金额为800元，那么您将享受400元的减免（800元的50%），只需支付400元即可获得新游戏中的相应档位权限。
    </p>
    <p>
      4.重要提示：为了确保您能够准确无误地享受减免政策，请您务必详细查看转游规则。规则中可能包含关于减免金额计算、适用条件、以及任何特殊情况的说明。
    </p>
    <p>
      5.规则变更：请注意，转游规则可能会根据游戏运营的需要进行调整。因此，在执行转游操作之前，请务必确认最新的转游规则。
      我们建议您在转游前仔细阅读并理解所有相关规则，以确保您的权益得到充分保障。如果您在阅读规则过程中有任何疑问，欢迎联系我们的客服团队，我们将竭诚为您解答。
      感谢您的理解与支持。
    </p>
  </div>
</template>
<style scoped>
.content {
  padding: 32px;
}
img {
  width: 100%;
}
h4 {
  margin: 18px 0;
}
p:nth-of-type(2),
p:nth-of-type(3) {
  margin-bottom: 60px;
}
.about {
  margin-top: 25px;
}
</style>
